import { useState } from "react";

export const faqs = [
  {
    q: "Can I get an emergency passport for deployment from Clarksville?",
    a: "Yes. We specialize in emergency deployment passport processing for Fort Campbell soldiers. With proper deployment orders, we can process new passports and renewals within 24-48 hours. Call us immediately when orders arrive — we work around the clock for military clients.",
  },
  {
    q: "Does my military ID count as proof of identity for passport applications?",
    a: "A military ID can be used as a secondary form of identification, but a state-issued driver's license or ID is required as the primary ID. For first-time passport applications (DS-11), you also need original proof of U.S. citizenship such as a birth certificate.",
  },
  {
    q: "My spouse needs a passport before my deployment — how fast can you process it?",
    a: "We understand that military deployments create urgent needs for spouses who want to travel home or visit family. Spouse passports follow the same emergency processing timeline — typically 48-72 hours for urgent cases. We expedite family member applications alongside soldier applications.",
  },
  {
    q: "Can you help with passport processing for minor children at Fort Campbell?",
    a: "Absolutely. Child passport applications require both parents to be present (or have documented consent). We coordinate timing to accommodate military duty schedules and can arrange off-hours appointments for active duty personnel.",
  },
  {
    q: "What's the closest passport office to Fort Campbell?",
    a: "The Atlanta Passport Agency at 805 Broadway is the nearest regional passport agency, approximately 50 miles from Fort Campbell. However, appointments are frequently unavailable with less than 2-3 weeks' notice. Our service eliminates the drive and the appointment uncertainty entirely.",
  },
  {
    q: "How do I get a passport during a PCS move to an OCONUS location?",
    a: "PCS moves to overseas locations require civilian passports for family members (soldiers travel on military orders). We handle the full documentation package including DD-1610 coordination and ensure passports are ready before your reporting date.",
  },
  {
    q: "Do you serve Oak Grove, Kentucky near Fort Campbell?",
    a: "Yes. We serve the entire Fort Campbell installation area including Oak Grove, KY and Hopkinsville, KY. Military communities on both sides of the Tennessee-Kentucky border regularly use our services.",
  },
];

export default function ClarksvilleFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Clarksville Passport Questions
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Answers to the most common passport questions from Fort Campbell military families and Clarksville residents.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-start justify-between gap-4 p-6 text-left cursor-pointer"
              >
                <span className="font-semibold text-[#1A365D] text-base leading-snug">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i
                    className={`ri-arrow-down-s-line text-[#1A365D] text-xl transition-transform ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}